import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
const { clinicId } = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{items:MasterTableDataType[],totalcount:number}>>=>{
    const result = await instance.post(`${MastersApi.getPurpose}`,{...params,clinicId});
    return result.data;
}

export const deleteMasterData = async (id:number):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.delete(`${MastersApi.deleteState}${id}`);
    return result.data;
}

export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.savePurpose}`,params);
    return result.data;
}

